export default "__VITE_ASSET__83d70f1b__"